module.exports = __webpack_public_path__ + "static/media/kargo.fcdbbe3e.jpg";